import React from 'react';

import { BusinessHoursPeriodBase } from '@flipdish/api-client-typescript';
import memoize from 'memoize-one';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import { getDateTimeFormatter2 } from '../../selectors/localeDateTime.selector';
import { createOpeningHoursByIdSelector } from '../../selectors/storeOpeningHours.selector';
import { formatOpeningHour } from '../common/formatTime';
import { createFormField } from './components/FormField';
import { DeliveryType } from './types';

const getFormId = (ownProps: Props) => `${ownProps.id}.${ownProps.name}`;

type MappedState = ReturnType<ReturnType<typeof mapStateToPropsFactory>>;
const mapStateToPropsFactory = (initialState, ownProps: Props) => {
  const openingHoursByIdSelector = createOpeningHoursByIdSelector(
    Number(ownProps.storeId),
    ownProps.deliveryType,
    ownProps.name
  );
  const formId = getFormId(ownProps);
  const component = createFormField(formId);
  const openingHourFormatted = memoize(formatOpeningHour);

  return (state: AppState) => {
    const translate = getTranslate(state.locale);
    const openingHourById = openingHoursByIdSelector(state);
    const openingHour = openingHourFormatted(
      openingHourById!,
      getDateTimeFormatter2(state),
      translate
    );

    const loading = !openingHour;

    return {
      openingHour,
      component,
      loading,
    };
  };
};

export interface IOpeningHoursFormItemProps {
  id: string;
  name: string;
  label: string;
  storeId: number | string;
  deliveryType: DeliveryType;
  autoFocus?: boolean;
  disabled?: boolean;
  isLast?: boolean;
  isFirst?: boolean;
  update(data: BusinessHoursPeriodBase): Promise<void>;
  updateAllDays(data: BusinessHoursPeriodBase): Promise<void>;
}
type Props = IOpeningHoursFormItemProps;

export default compose<Props & MappedState, IOpeningHoursFormItemProps>(
  setDisplayName('OpeningHoursFormItem'),
  connect(mapStateToPropsFactory)
)(({
  label,
  name,
  update,
  openingHour,
  component: FormField,
  loading,
  autoFocus,
  disabled,
  isFirst,
  isLast,
  id,
  updateAllDays,
  deliveryType,
}) => {
  return (
    <FormField
      id={id}
      deliveryType={deliveryType}
      label={label}
      name={name}
      update={update}
      updateAllDays={updateAllDays}
      openingHour={openingHour}
      loading={loading}
      autoFocus={autoFocus}
      disabled={disabled}
      isFirst={isFirst}
      isLast={isLast}
    />
  );
});
